import revive_payload_client_4sVQNw7RlN from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/var/www/html/collection-experience/frontend-2/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/var/www/html/collection-experience/frontend-2/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_ghbUAjaD3n from "/var/www/html/collection-experience/frontend-2/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import formkitPlugin_pZqjah0RUG from "/var/www/html/collection-experience/frontend-2/.nuxt/formkitPlugin.mjs";
import nuxt_plugin_6wEQMY3tee from "/var/www/html/collection-experience/frontend-2/node_modules/nuxt-delay-hydration/dist/runtime/nuxt-plugin.js";
import ScrollSmoother_client_2kGh7qOicq from "/var/www/html/collection-experience/frontend-2/plugins/ScrollSmoother.client.js";
import gsap_client_Z6XKCRtOCT from "/var/www/html/collection-experience/frontend-2/plugins/gsap.client.js";
import labels_gjL1JY5CpA from "/var/www/html/collection-experience/frontend-2/plugins/labels.js";
import masonry_client_hAWcSSBafZ from "/var/www/html/collection-experience/frontend-2/plugins/masonry.client.js";
import scroll_08MQiDypDv from "/var/www/html/collection-experience/frontend-2/plugins/scroll.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_ghbUAjaD3n,
  formkitPlugin_pZqjah0RUG,
  nuxt_plugin_6wEQMY3tee,
  ScrollSmoother_client_2kGh7qOicq,
  gsap_client_Z6XKCRtOCT,
  labels_gjL1JY5CpA,
  masonry_client_hAWcSSBafZ,
  scroll_08MQiDypDv
]